import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useClient } from "@adamlip/okeoke.client";
import ClipLoader from "react-spinners/ClipLoader";

export default function SelectLocation() {
  const { uuid } = useParams();
  const { setSelectedLocation } = useClient();
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      console.log("Select location in SelectMenu.js 13");
      setSelectedLocation(uuid?.toUpperCase());
      navigate("/menu");
    }, 2000);
    // eslint-disable-next-line
  }, []);

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <ClipLoader />
    </div>
  );
}
